import Vue from 'vue'
Vue.directive('digitsonly', {
  bind: function(el) {
    el.addEventListener('input', function(e) {
      let input = e.target;
      input.value = input.value.replace(/\D/g, ''); // Удалить все символы, кроме цифр
    });
  }
});